import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { useGraphQL } from "@/hooks/use-graphql";
import { EditAddressForm } from "@/components/profile/personal-data/edit-address-form";

import type { JSX } from "react";

const EditAddressPageQuery = graphql(/* GraphQL */ `
  query EditAddressPageQuery {
    ...EditAddressFormFragment
  }
`);

const EditAddressPage = (): JSX.Element => {
  const queryResult = useGraphQL(EditAddressPageQuery, {});
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Editar Endereço" align="center" />
      </HeaderRoot>
      <Page className="px-6 py-8">
        <AsyncDataWrapper {...queryResult}>
          {data ? <EditAddressForm data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/personal-data/edit-address")({
  component: EditAddressPage,
});
